
import apiClient from "./axois.config-buy";
const buymoduleService={
    // this function used to retriew the NewProperties 
 newProperties()
{
    return apiClient.get("/website/buy/property/newly-arrived")
},
// this function is to get the Recommended Properties list
recomendedProperties()
{
    return apiClient.get("/website/buy/property/featured")
},


//this function is used to retrieve the Buy Properties list
buyPropertiesList(payload)
{
    return apiClient.post("/website/buy/property/listings", payload);
},

// this function is used to retrieve the Property details
propertyDetails(propertyurl , propertyId)

{
   const params={
        propertyURL: propertyurl,
        propertyId: propertyId,
    }
    return apiClient.get("/website/buy/property-detail",{params});
},


//this function is used to retrieve the all locations
allLocations()
{
    return apiClient.get("/website/buy/property/locations");
},
// this api is for search location suggestions
searchlocationSuggestions(search){
    const params=
    {
        locName:search,
    }
        return apiClient.get("/website/buy/property/locations/autocomplete",{params});
},
//this function is to get the property type from  database
allPropertyType()
{
    return apiClient.get("/website/buy/property/types");
},
//this functrion is used to fetch the all bhktypes
allbhk()
{
    return apiClient.get("/website/buy/property/bhk-types");
},
//this function is used to send the schedule visit data admin
sendScheduleVisit(visitData)
{
      const payload = {
    propertyId: visitData.propertyId, 
    visitDate: visitData.visitDate,
    visitTime: visitData.visitTime,
    visitorName: visitData.visitorName,
    visitorEmail: visitData.visitorEmail,
    visitorContact: visitData.visitorContact,
    propertyUrl: visitData.propertyUrl, 
    propertyName:visitData.propertyName
  };

    return apiClient.post("/website/buy/schedule-visit",payload)
},


//this api are used to add to or remove wishlist wishlist function
addWishlist(propertyGuid ){
   
    return apiClient.post("/customer/buy/wishlist/add",{PropertyGuid:propertyGuid} )
},
removeWishlist(wishlistId ){
    // console.log("wishList ID came",wishlistId)
    return apiClient.delete(`/customer/buy/wishlist/remove/${wishlistId}` )
},
getWishlist()
{
    return apiClient.get("/customer/buy/wishlist/get-wishlist")
},
addRemoveToggleWishlist(propertyGuid)
{
    apiClient.get("/customer/buy/wishlist/add-or-remove",null,{ params: { propertyGuid } })
},

}

export default buymoduleService;
